import React, { useState } from 'react';
import { updateCategoriaTarea } from '../services/tareasService';
import { getCategoriasByArea } from '../services/Admin/categoriaService';
import './styles/components.css';

const CambiarCategoriaButton = ({ tareaId, areaId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categorias, setCategorias] = useState([]);
  const [selected, setSelected] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleOpenModal = async () => {
    setIsModalOpen(true);
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      const data = await getCategoriasByArea(areaId);
      setCategorias(data);
    } catch (e) {
      setError('Error al cargar categorías');
    }
    setLoading(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelected('');
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selected) {
      setError('Seleccione una categoría');
      return;
    }
    setLoading(true);
    const resp = await updateCategoriaTarea(tareaId, selected);
    if (resp.success) {
      setSuccess('Categoría actualizada');
      setTimeout(() => {
        handleCloseModal();
        window.location.reload(); // Recargar la página para mostrar los cambios
      }, 1000);
    } else {
      setError(resp.message);
    }
    setLoading(false);
  };

  return (
    <>
      <button className="category-btn" onClick={handleOpenModal} style={{ fontSize: '14px' }}>
        Cambiar categoría
      </button>
      {isModalOpen && (
        <div className="modal-permisos-backdrop">
          <div className="modal-permisos-container" style={{ minWidth: 350, maxWidth: 400 }}>
            <div className="modal-permisos-header">
              <h2 className="modal-permisos-title">Cambiar Categoría</h2>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-permisos-body">
                {loading && <p>Cargando...</p>}
                {error && <div style={{ color: 'red', marginTop: '8px' }}>{error}</div>}
                {success && <div style={{ color: 'green', marginTop: '8px' }}>{success}</div>}
                {!loading && categorias.length > 0 && (
                  <div className="form-group">
                    <label htmlFor="categoria">Categoría:</label>
                    <select
                      id="categoria"
                      value={selected}
                      onChange={e => setSelected(e.target.value)}
                      style={{ width: '100%', padding: '8px', marginTop: '8px', borderRadius: '4px', border: '1px solid #e0e0e0' }}
                    >
                      <option value="">Seleccione una categoría</option>
                      {categorias.map(cat => (
                        <option key={cat.id_categoria} value={cat.id_categoria}>{cat.nombre}</option>
                      ))}
                    </select>
                  </div>
                )}
                {!loading && categorias.length === 0 && (
                  <p>No hay categorías disponibles para este área</p>
                )}
              </div>
              <div className="modal-permisos-actions">
                <button type="button" onClick={handleCloseModal}
                  style={{ padding: '8px 16px', marginRight: '8px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                >
                  Cancelar
                </button>
                <button type="submit" disabled={loading || !selected}
                  style={{ padding: '8px 16px', backgroundColor: loading || !selected ? '#6c757d' : '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: loading || !selected ? 'not-allowed' : 'pointer' }}
                >
                  {loading ? 'Actualizando...' : 'Actualizar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default CambiarCategoriaButton;
